export default "__VITE_ASSET__BB1LGU62__"